import { Box, colors, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as BolLogo } from '../../../../styles/svg/bol.svg';
import { ReactComponent as CirroLogo } from '../../../../styles/svg/cirro.svg';
import { ReactComponent as DhlLogo } from '../../../../styles/svg/dhl.svg';
import { ReactComponent as DhlGermanyLogo } from '../../../../styles/svg/dhlgermany.svg';
import { ReactComponent as DpdLogo } from '../../../../styles/svg/dpd.svg';
import { ReactComponent as GlsLogo } from '../../../../styles/svg/gls.svg';
import { ReactComponent as InnosendLogo } from '../../../../styles/svg/innosend.svg';
import { ReactComponent as IntrapostLogo } from '../../../../styles/svg/intrapost.svg';
import { ReactComponent as MyparcelLogo } from '../../../../styles/svg/myparcel.svg';
import { ReactComponent as ParcelLogo } from '../../../../styles/svg/parcel.svg';
import { ReactComponent as PostNLLogo } from '../../../../styles/svg/postnl.svg';
import { ReactComponent as SendcloudLogo } from '../../../../styles/svg/sendcloud.svg';
import { ReactComponent as UpsLogo } from '../../../../styles/svg/ups.svg';
import { ReactComponent as TrunkrsLogo } from '../../../../styles/svg/trunkrs.svg';
import { ReactComponent as CycloonLogo } from '../../../../styles/svg/cycloon.svg';
import { ReactComponent as MyparcelcomLogo } from '../../../../styles/svg/myparcelcom.svg';
import { ReactComponent as AmpereLogo } from '../../../../styles/svg/ampere.svg';
import { ReactComponent as HstLogo } from '../../../../styles/svg/hst.svg';
import { ReactComponent as ZinepsLogo } from '../../../../styles/svg/zineps.svg';
import { ReactComponent as VinologixLogo } from '../../../../styles/svg/vinologix.svg';
import { ReactComponent as WegrowLogo } from '../../../../styles/svg/wegrow.svg';
import { QuestionMarkOutlined } from "@mui/icons-material";
import { GridCheckIcon } from "@mui/x-data-grid";
import { ClearIcon } from "@mui/x-date-pickers";
import BaseCard from "../../../theme/cards/BaseCard";
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Text from "../../../theme/text/Text";

export const WarehouseSettingShipperCard = (props) => {
    const theme = useTheme();
    const { t,i18n } = useTranslation();

    let status = props.state;
    // let labelcolor = theme.palette.mode === "dark" ? "greyLight" : "grey";
    // let labeltext = t('unknown');
    // const { labelcolor, labeltext } = getReturnStateData(props.state, theme);
   

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <>
                                <Box
                                    sx={{
                                        display:"flex",
                                    }}
                                >
                                    <Box sx={{ paddingRight: '10px' }}>
                                        {props.type === "postnl" ? <PostNLLogo width={30} height={30}/> : null}
                                        {props.type === "dhl" ? <DhlLogo  width={30} height={30}/> : null}
                                        {props.type === "dpd" ? <DpdLogo width={30} height={30}/> : null}
                                        {props.type === "bol" ? <BolLogo width={30} height={30}/> : null}
                                        {props.type === "other" ? <QuestionMarkOutlined width={30} height={30}/> : null}
                                        {props.type === "parcel" ? <ParcelLogo width={30} height={30}/> : null}
                                        {props.type === "cirro" ? <CirroLogo width={30} height={30}/> : null}
                                        {props.type === "sendcloud" ? <SendcloudLogo width={30} height={30}/> : null}
                                        {["innosend", "innosendv2"].includes(props.type) ? <InnosendLogo width={30} height={30}/> : null}
                                        {props.type === "intrapost" ? <IntrapostLogo width={30} height={30}/> : null}
                                        {props.type === "myparcel" ? <MyparcelLogo width={30} height={30}/> : null}
                                        {props.type === "myparcelcom" ? <MyparcelcomLogo width={30} height={30}/> : null}
                                        {props.type === "ups" ? <UpsLogo width={30} height={30}/> : null}
                                        {props.type === "gls" ? <GlsLogo width={30} height={30}/> : null}
                                        {props.type === "trunkrs" ? <TrunkrsLogo width={30} height={30}/> : null}
                                        {props.type === "cycloon" ? <CycloonLogo width={30} height={30}/> : null}
                                        {props.type === "hst" ? <HstLogo width={30} height={30}/> : null}
                                        {props.type === "ampere" ? <AmpereLogo width={30} height={30}/> : null}
                                        {props.type === "dhlgermany" ? <DhlGermanyLogo width={30} height={30}/> : null}
                                        {props.type === "zineps" ? <ZinepsLogo width={30} height={30}/> : null}
                                        {props.type === "vinologix" ? <VinologixLogo width={30} height={30}/> : null}
                                        {props.type === "wegrow" ? <WegrowLogo width={30} height={30}/> : null}
                                    </Box>
                                    <Box
                                        sx={{
                                            display:"flex",
                                            flexDirection:'column'
                                        }}
                                    >
                                        <Text bold>{props.name}</Text>
                                        <Text light>{props.reference}</Text>
                                    </Box>
                                </Box>
                            </>
                        }
                    </Box>
                    <Box 
                        sx={{
                            mt:2,
                            display:"flex",
                            gap:3,
                        }}
                    >
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("max_size")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                <>
                                    <Text>
                                        {`${props.maxWidth}mm x ${props.maxLength}mm x ${props.maxHeight}mm`}
                                    </Text>
                                    <Text semibold italic>
                                        {`(${props.maxVolume} mm3)`} {props.maxWeight && `${props.maxWeight} ${t("gram")}` }
                                    </Text>
                                </>
                            }
                        </Box>

                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("pickup_times")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                <>
                                    <Text>
                                        {`${props.standard_time ? new Date(new Date(props.standard_time).getTime() - (60 * 60 * 1000)).toLocaleString('en-US', {hour: '2-digit', minute:'2-digit', hour12: false}) : '-'} | ${props.standard_time_saturday ? new Date(new Date(props.standard_time_saturday).getTime() - (60 * 60 * 1000)).toLocaleString('en-US', {hour: '2-digit', minute:'2-digit', hour12: false}) : '-'} | ${props.standard_time_sunday ? new Date(new Date(props.standard_time_sunday).getTime() - (60 * 60 * 1000)).toLocaleString('en-US', {hour: '2-digit', minute:'2-digit', hour12: false}) : '-'}`}
                                    </Text>
                                </>
                            }
                        </Box>
                    </Box>

                    <TopRight>
                        <CardLabel 
                            variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                            hasright 
                            fitted
                            colorflip={theme.palette.mode !== "dark"}
                            position="child-tr"
                        >
                            {props.warehouses?.length === 0 ? (
                                t("no_warehouses")
                            ) : (
                                <Box
                                    sx={{
                                        display:"flex",
                                        gap:1,
                                        alignItems:'center',
                                        px:0.5,
                                    }}
                                >
                                    {props.warehouses.length}
                                    <WarehouseOutlinedIcon fontSize="small"/>
                                </Box>
                            )}
                        </CardLabel>
                        <CardLabel hasleft fitted variant={props.alternativeAddress ? "green" : "red"} position="child-tr">
                            {props.alternativeAddress ? (
                                <GridCheckIcon sx={{ color: colors.green[400] }} />
                            ) : (
                                <ClearIcon sx={{ color: colors.red[400] }} />
                            )}
                        </CardLabel>
                    </TopRight>
                </Box>
            </Box>
        </BaseCard>
    )
}